<template>
  <div class="home" ref="home">
    <!-- 页面头部 -->
    <div style="width:100%;position: relative;;">
      <div
        style="position: absolute;width:100%;height:48px;bottom:0;left:0;background: #122266;"
      ></div>
      <pageHeader ref="pageHeader" pageStatus="1" />
    </div>
    <!-- 轮播图 -->
    <div class="swiper_banner">
      <Banner ref="Swiper" />
    </div>

    <!-- 内容 -->
    <div class="home-box">
      <!-- 热门套餐 -->
      <div class="popular-package">
        <div class="popular-desc">
          <div class="popular-tit">
            <img src="../assets/home/mobile/hot-dot-icon.png" alt="" />
            <div>热门检测套餐</div>
          </div>
          <div class="view-more" @click="jumpPopularList()">查看更多></div>
        </div>
        <div class="popular-show">
          <swiper :options="swiperOption">
            <swiper-slide 
                v-for="(item, idx) in popularList" 
                :key="'1-' + idx">
              <div
                class="popular-item"
                @click="jumpDetail(item)"
              >
                <div class="popular-item-ctn">
                  <div class="popular-item-img">
                    <img :src="$path + item.imageUrl" alt="" />
                  </div>
                  <img
                    class="hot-img"
                    src="../assets/home/mobile/hot-icon.png"
                    alt=""
                  />
                  <div class="popular-item-name">
                    <div class="item-name">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 行业解决方案 -->
      <div class="solution">
        <div class="solution-title">行业解决方案</div>
        <div class="solution-desc">国联为多行业客户高质量发展保驾护航</div>
        <div class="classify-box">
          <div class="classify-box-row"
            v-for="(solution, idx) in solutionList"
            :key="idx">
            <div
              class="classify-item"
              :class="{ active: item.select, 'm-r-11': (_idx+1)%4 != 0 }"
              v-for="(item, _idx) in solution"
              :key="item.id"
              @click="showTwoLevel(item)"
            >
              <div class="classify-item-icon">
                <img
                  class="icon-img"
                  :src="$path + item.mobileLogoUrl"
                  alt=""
                />
              </div>
              <div class="classify-item-name" :class="{ active: item.select }">
                {{ item.name }}
              </div>
            </div>
          </div>
          
        </div>
          
        <div class="two-classify-box" v-if="solutionTwoLevelList.length">
          <div class="scroll-box" id="scroll-box">
            <div class="scroll-inn">
              <div
                class="two-classify-item"
                v-for="(item, pid) in solutionTwoLevelList"
                :key="item.id"
              >
                <div class="two-classify-item-tit">
                  <div class="two-classify-item-name">
                    {{ item.name }}
                  </div>
                  <div
                    class="two-classify-item-more"
                    @click="jumpToClass(item)"
                  >
                    更多>
                  </div>
                </div>
                <div
                  class="three-classify-item-tit"
                  v-if="item.productList.length"
                >
                  <div
                    class="three-classify-item-name"
                    :class="{ 'm-r-22': idx % 2 == 0}"
                    v-for="(citem, idx) in item.productList.slice(0,2)"
                    :key="citem.id"
                    @click="jumpToClass(item, citem)"
                  >
                    {{ citem.name }}
                  </div>
                </div>
                <div class="two-classify-item-line" v-if="pid + 1 != solutionTwoLevelList.length" ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 实验室 -->
      <div class="lab">
        <div class="lab-title">实验室遍布全国</div>
        <div class="lab-desc">3万平米自有智能实验室，200家国内外签约实验室</div>
        <div class="lab-show-box">
          <div class="lab-show-box-pop"></div>
          <swiper :options="labSwiperOption">
            <swiper-slide 
                v-for="(item, idx) in labData"
                :key="idx">
              <div class="lab-show-item">
                <div class="lab-show-item-ctn">
                  <img :src="$path + item.url" alt="" />
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 关于 -->
      <div class="abort" @click="jumpToAbort()">
        <div class="abort-title">关于国联质检</div>
        <div class="abort-desc">十年发展历程，坚持“让检测还人类绿色生活”</div>
        <div class="cmp-img">
          <img src="../assets/home/mobile/abort.png" alt="" />
          <div class="cmp-name">
            西安国联质量检测技术股份有限公司
          </div>
        </div>
        <div class="introduction">
          <p class="">
            法定综合性第三方检测认证机构，提供检验检测、认证、安全评价、监督抽查、环境评价、环境治理、产品研发 、咨询培训 、未知物分析等服务。
          </p>
          <p class="introd-text">
            集团成立于 2011 年，在全国拥有超过 30000 ㎡实验室，700 多名专业技术人员，服务能力覆盖 42 个领域、121 个大类、6000+ 个参数，合作客户超过 10 万 +，累计出具报告 60 万余份。
          </p>
        </div>
        <div class="skill">
          <div class="skill-row-one">
            <div
              class="skill-one-item"
              v-for="(item, idx) in skill.rowTop"
              :key="idx"
            >
              <div class="skill-one-item-img">
                <img :src="item.icon" alt="" />
              </div>
              <div class="skill-desc">
                <div class="skill-desc-num">
                  <span>{{ item.num }}</span
                  >{{ item.unit }}
                </div>
                <div class="skill-desc-text">{{ item.content }}</div>
              </div>
            </div>
          </div>
          <div class="skill-row-two">
            <div
              class="skill-two-item"
              v-for="(item, idx) in skill.rowBottom"
              :key="idx"
            >
              <div class="skill-one-item-img">
                <img :src="item.icon" alt="" />
              </div>
              <div class="skill-desc">
                <div class="skill-desc-num">
                  <span>{{ item.num }}</span
                  >{{ item.unit }}
                </div>
                <div class="skill-one-desc-text">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 合作客户 -->
      <div class="customer" :style="'background-image: url(' + blueBg + ')'">
        <div class="customer-title">合作客户</div>
        <div class="customer-desc">700余人精英专家团队，10万+累计服务客户</div>
        <div class="customer-show">
          <div
            class="customer-item"
            v-for="(item, idx) in customersList"
            :key="idx"
          >
            <img :src="$path + item.image" alt="" />
          </div>
        </div>
      </div>
    </div>

    <consultForm ref="consultForm" />

  </div>
</template>

<script>

import Banner from '@/components/swiper'
// import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.js'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import axios from '@/http'
import blueBg from '../assets/home/mobile/blue-bg.png'
import skill1 from '../assets/home/mobile/skill-1.png'
import skill2 from '../assets/home/mobile/skill-2.png'
import skill3 from '../assets/home/mobile/skill-3.png'
import skill4 from '../assets/home/mobile/skill-4.png'
import skill5 from '../assets/home/mobile/skill-5.png'
export default {
  name: 'home-mb',
  computed: {},
  components: {
    Banner,
    pageHeader: () => import('@/components/header'),
    consultForm: () => import('@/components/consult'),
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  watch: {
    $route() {
      this.type = this.$route.query.type
      this.$refs.solution.scrollTop = 750
    },
  },
  data() {
    return {
      /***    背景图    *** */

      blueBg,
      /***    背景图 end   *** */

      skill: {
        rowTop: [
          {
            num: 40,
            unit: '+',
            icon: skill1,
            content: '业务领域',
          },
          {
            num: 3,
            unit: '万平',
            icon: skill2,
            content: '智能实验室',
          },
          {
            num: 10,
            unit: '万+',
            icon: skill3,
            content: '服务客户',
          },
        ],
        rowBottom: [
          {
            num: 100,
            unit: '+',
            icon: skill4,
            content: '资质荣誉',
          },
          {
            num: 700,
            unit: '+',
            icon: skill5,
            content: '专家团队',
          },
        ],
      },

      
      /***    以下变量控制实验室动画    *** */

      labCanMove: false, // 是否可以滚动
      labFirstLeft: 0, // 位置信息
      labLastLeft: 0, // 位置信息
      labFirstRestart: false, // 是否重置
      labLastRestart: false, // 是否重置
      /***    以上变量控制实验室动画  end   *** */

      labData: [], // 实验室
      popularList: [], // 热门套餐全部数据

      solutionList: [], // 行业解决方案
      firstLevelsolution: {}, // 点击的一级方案
      solutionTwoLevelList: [], // 二级行业解决方案
      customersList: [], // 行业客户

      swiperOption: {
        
        slidesPerView: 'auto',
        spaceBetween: 0,
        
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
          },
      },
      labSwiperOption: {
        
        observer:true,
        freeMode: true,

        slidesPerView: 'auto',
        observeParents: true,//修改swiper的父元素时，自动初始化swiper  
        spaceBetween: 0,
        loop: true,
        speed: 1900, //滚动速度
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
      }
    }
  },
  created() {
    
    // 设置rem
    document.documentElement.style.fontSize =
    document.documentElement.clientWidth / 7.5 + 'px'
    
    this.getPopularList()
    this.getLabList()

    this.getSolutionList()

    this.getIndustryCustomersList()
    // resize事件
    window.onresize = () => {
      if(document.documentElement.clientWidth < 950) {
        // 设置rem
        document.documentElement.style.fontSize =
        document.documentElement.clientWidth / 7.5 + 'px'
      }
    }
  },
  mounted() {
    const obj = {
      platformType: 0,
      targetPage: '',
    }
    if (this.commonClass === 'pc') {
      obj.platformType = 1
    } else {
      obj.platformType = 2
    }
    obj.targetPage = window.location.href
    this.$api.iotHome.loggingData(obj).then((res) => {
      if (res.data.success == true) {
        console.log('数据记录成功')
      }
    })

  },
  methods: {
    // 热门套餐
    getPopularList() {
      this.$api.iotHome.hotProductlist({}).then((res) => {
        if (res.data.success == true) {
          this.popularList = res.data.data
        }
      })
    },
    // 获取实验室数据
    getLabList() {
      this.$api.iotHome.getLaboratoryImageList().then((res) => {
        if (res.data.success == true) {
          this.labData = res.data.data
          
          // this.labSwiperInit()
        }
      })
    },
    // 行业解决方案
    getSolutionList() {
      this.$api.iotHome.mobileTypeList().then((res) => {
        if (res.data.success == true) {
          res.data.data[0].select = true

          const arr = []
          
          res.data.data.forEach((item, idx) => {
            if(idx % 4 === 0) {
              arr[arr.length] = []
            } 
            arr[arr.length - 1].push(item)
          })
          this.solutionList = arr
          this.showTwoLevel(res.data.data[0])
        }
      })
    },
    // 获取二级行业信息
    showTwoLevel(pitem) {
      const {id} = pitem
      this.$api.iotHome.mobileTypeProductList({ id }).then((res) => {
        this.solutionList.forEach((item) => {
          item.forEach(item => {
            item.select = false
            item.id === id && (item.select = true)
          })
        })
        this.firstLevelsolution = pitem
        if (res.data.success == true) {
          this.solutionTwoLevelList = res.data.data
          // 添加滚动事件
          // this.addScrollEvent()
        }
      })
    },
    // 行业客户
    getIndustryCustomersList() {
      this.$api.iotHome
        .getArticleList({
          columnId: 102,
          rows: 20,
          page: 1,
        })
        .then((res) => {
          if (res.data.success == true) {
            this.customersList = res.data.data.rows
            let arr = res.data.data.rows
            if (arr.length > 18) {
              arr.length = 18
            }
            this.customersList = [...arr]
          }
        })
    },
    // 实验室动画初始化
    labSwiperInit() {
      const labFirstIndex = 0
      const labLastIndex = this.labData.length

      // this.labLastLeft = `${(this.labData.length * 2.94).toFixed(2)}rem`
        this.labLastLeft = `translate3d(${(this.labData.length * 2.94).toFixed(2)}rem, 0, 0)`
      // transform: translate3d(40px, 0, 0);

      setTimeout(() => {
        this.labCanMove = true
        this.labSwiper(labFirstIndex, labLastIndex, 1)
      }, 100)
    },
    // 实验室动画
    labSwiper(labFirstIndex, labLastIndex, mark) {
      // 重置状态
      this.labLastRestart = false
      this.labFirstRestart = false
      // 判断边界
      if (labLastIndex == 0) {
        labFirstIndex = this.labData.length - 1
        this.labFirstLeft = `translate3d(${(labFirstIndex * 2.94).toFixed(2)}rem, 0, 0)`
        this.labFirstRestart = true
      } else {
        labFirstIndex--
        this.labFirstLeft = `translate3d(${(labFirstIndex * 2.94).toFixed(2)}rem, 0, 0)`
      }

      // 判断边界
      if (!mark && labFirstIndex == -1) {
        labLastIndex = this.labData.length - 1
        
        this.labLastLeft = `translate3d(${(labLastIndex * 2.94).toFixed(2)}rem, 0, 0)`
        this.labLastRestart = true
      } else {
        labLastIndex--
        this.labLastLeft = `translate3d(${(labLastIndex * 2.94).toFixed(2)}rem, 0, 0)`
      }

      setTimeout(() => {
        this.labSwiper(labFirstIndex, labLastIndex)
      }, 2000)
    },
    // 跳转套参列表
    jumpPopularList() {
      // this.$router.push('/standardSetMeal')
      window.open('/standardSetMeal')
    },
    // 跳转套餐
    jumpDetail({ relationId }) {
      window.open(`/detectionDetail/?id=${relationId}`)
    },
    // 跳转解决方案
    jumpToClass(pitem, citem) {
      let url;
      if(citem) {
        url = `/detectionDetail?id=${citem.id}`
      } else {
        url = `/detection?id=${this.firstLevelsolution.id}&name=${this.firstLevelsolution.name}&twoLeve=${pitem.id}`
      }
      window.open(url)
    },
    // 跳转关于
    jumpToAbort() {
      window.open('/aboutMe')
    },
    
    show53() {
      const specs =
        'height=600,width=1000,alwaysRaised,directories=no,toolbar=no,titlebar=no,menubar=no,scrollbars=no,left=300,top = 200, resizable=no,location=no, status=no'
      window.open(
        'https://ada.baidu.com/site/wjzzrg3w/agent?imid=d55b08de4f857a0038a33d33ef9afaf7',
        '_blank',
        specs
      )
    },
  },
}
</script>
<style lang="scss" scoped>
@import url('../style/home.css');

.home-box {
  width: 100%;
  height: auto;
  background: #eceff6;
}
.popular-package {
  padding: 0.5rem 0.24rem;
}
.popular-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba($color: #d8d8d8, $alpha: 0.7);
  padding-block: 5px;
  .popular-tit {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #282b45;
    line-height: 35px;
    img {
      width: 0.34rem;
      height: 0.41rem;
      display: inline-block;
      margin-right: 0.16rem;
    }
  }
  .view-more {
    color: #777995;
    font-size: 14px;
  }
}

.popular-show {
  margin-top: 20px;
  max-width: 100%;
  // height: 2.82rem;
  overflow: hidden;
  position: relative;
  
  .swiper-slide {
    // width: 37.1%;
    width: auto;
  }
  .popular-show-box {
    // overflow: hidden;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .popular-item {
    width: 2.81rem;
    // height: 2.82rem;
    position: relative;
    padding-right: 0.1rem;
    float: left;
  }
  .popular-item-ctn {
    width: 2.71rem;
    // height: 2.82rem;
    position: relative;
    background: #fff;
  }
  .popular-item-img {
    width: 100%;
    height: 1.62rem;
  }
  img {
    height: 100%;
    width: 100%;
  }
  .hot-img {
    width: 0.58rem;
    height: 0.34rem;
    position: absolute;
    top: 1.5rem;
    left: 0.1rem;
  }
  .popular-item-name {
    height: .86rem;
    padding: 0.2rem 0.28rem;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #282b45;
    line-height: 0.39rem;
    display: flex;
    align-items: center;
    
    .item-name {
      // text-overflow:ellipsis;    
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
// 行业解决方案
.solution {
  width: 100%;
  background-color: #333f53;
  background-size: 100%;
  padding: 0 0.11rem;
  padding-top: 0.9rem;
  padding-bottom: 0.8rem;
}
.solution-title {
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 39px;
  text-align: center;
}
.solution-desc {
  margin-top: 0.2prem;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #abaecd;
  line-height: 24px;
  text-align: center;
}
.classify-box {
  margin-top: 0.58rem;
  width: 100%;

  padding: 0 0.12rem;
}
.classify-box-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin: 0.09rem 0;
}
.classify-item {
  width: 1.68rem;
  height: 1.68rem;
  background: #ffffff;
  border-radius: 0.16rem;
  &.m-r-11 {
    margin-right: 0.11rem;
  }
  &.active {
    background: linear-gradient(0deg, #224cff 0%, #3f65ff 100%);
  }
}
.classify-item-icon {
  width: 100%;
  height: 0.88rem;
  display: flex;
  justify-content: center;
  padding-top: 0.4rem;
  .icon-img {
    width: 0.5rem;
    height: 0.5rem;
  }
}
.classify-item-name {
  text-align: center;
  padding: 0.05rem .07rem 0;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #282B45;
  line-height: 0.3rem;
  height: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  // -webkit-line-clamp: 2; //行数
  -webkit-box-orient: vertical;
  &.active {
    color: #fff;
  }
}
.two-classify-box {
  width: 7.04rem;
  margin: 0 auto;
  // background: linear-gradient(0deg, #224cff 0%, #4065ff 100%);
  background: linear-gradient(-22deg, #0127E8 0%, #4065FF 100%);
  
  border-radius: 0.16rem;
  margin-top: 0.38rem;
  overflow: hidden;
  padding: 0.4rem 0 0.5rem;
  position: relative;
  &:before {
    content: '';
    width: 2.61rem;
    height: 2.12rem;
    position: absolute;
    bottom: 0;
    right: 0;
    background: url('../assets/home/mobile/solution-tipbg.png') center no-repeat;
    background-size: contain;
  }
}

.scroll-box {
  width: 100%;
  // max-height: 8.38rem;
  padding: 0 0.3rem;
  // overflow: scroll;
}
.scroll-inn {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}
.two-classify-item-tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.two-classify-item {
  position: relative;
  overflow: hidden;
}
.two-classify-item-line {
  width: 100%;
  height: 0.3rem;
}
.two-classify-item-name {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 0.3rem;
  padding-left: 0.27rem;
  position: relative;
  &:before {
    content: '';
    width: 0.07rem;
    height: 0.30rem;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.two-classify-item-more {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.27rem;
  opacity: 0.6;
}
.three-classify-item-tit {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0.12rem;
}
.three-classify-item-name {
  width: 3.1rem;
  line-height: 0.6rem;
  height: 0.6rem;
  font-size: 13px;
  border: 1px solid #546ee1;
  border-radius: 0.1rem;
  // margin-bottom: 0.13rem;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.75);
  overflow: hidden;    
  text-overflow:ellipsis;    
  white-space: nowrap;
  padding: 0 0.3rem;
  &.m-r-22 {
    margin-right: 0.22rem;
  }
  &.m-b-0 {
    margin-bottom: 0;
  }
}

// 图书馆
.lab {
  background: #fff;
  padding: 0.87rem 0.23rem;
}

.lab-title {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282b45;
  line-height: 0.39rem;
  text-align: center;
}
.lab-desc {
  margin-top: 0.2rem;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #777995;
  line-height: 0.24rem;
  text-align: center;
}
.lab-show-box {
  width: 100%;
  height: 2.13rem;
  margin-top: 0.41rem;
  overflow: hidden;
  position: relative;
  .lab-show-box-pop {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;

  }
  .swiper-slide {
    width: auto;
  }
  .lab-scroll-box {
    height: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
  }
  .lab-show-item {
    height: 2.13rem;
    width: 2.94rem;
    padding-right: 0.1rem;
  }
  .lab-show-item-ctn {
    height: 2.13rem;
    width: 2.84rem;

  }
  img {
    width: 100%;
    height: 100%;
  }
}

.lab-show-box-self {
  width: 100%;
  height: 2.13rem;
  margin-top: 0.41rem;
  overflow: hidden;
  position: relative;
  .lab-scroll-box {
    height: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
  }
  .lab-show-item {
    height: 2.13rem;
    width: 2.84rem;
    float: left;
    margin-right: 0.1rem;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

// 关于
.abort {
  padding-top: 0.89rem;
}
.abort-title {
  text-align: center;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282b45;
  line-height: 0.39rem;
}
.abort-desc {
  margin-top: 0.2rem;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #777995;
  line-height: 0.24rem;
  text-align: center;
}
.cmp-img {
  position: relative;
  width: 100%;
  height: 5.11rem;
  margin-top: 0.43rem;
  img {
    width: 100%;
    height: 100%;
  }
  .cmp-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.57rem 0.2rem 0.42rem;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 0.27rem;
    // text-align: center;
    background: rgba($color: #0f121e, $alpha: 0.8);
    overflow: hidden;    
    text-overflow:ellipsis;    
    white-space: nowrap;
  }
}
.introduction {
  background: #3b3e49;
  padding: 0.67rem 0.2rem;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.43rem;
  .introd-text {
    margin-top: 0.1rem;
  }
}

.skill {
  padding: 0.31rem 0.2rem;
  padding-bottom: 0;
}
.skill-row-one {
  display: flex;
  justify-content: space-around;
}
.skill-one-item {
  width: 2.26rem;
  height: 3.09rem;
  padding-top: 0.66rem;
  background-color: #fff;
  border-radius: 0.18rem;
}
.skill-one-item-img {
  width: 0.55rem;
  height: 0.55rem;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.skill-desc {
  text-align: center;
  margin-top: 0.51rem;
  .skill-desc-num {
    font-size: 15px;
    line-height: 0.41rem;
    span {
      color: #224cff;
      font-size: 36px;
      font-family: SourceHanSansCN-Regular;
      font-weight: Regular;
    }
  }
  .skill-one-desc-text {
    font-family: Bahnschrift !important;;
  }
  .skill-desc-text {
    font-family: Bahnschrift !important;;
  }
}
.skill-row-two {
  display: flex;
  justify-content: space-around;
  margin-top: 0.2rem;
}
.skill-two-item {
  width: 3.41rem;
  height: 3.09rem;
  background-color: #fff;
  border-radius: 0.18rem;
  padding-top: 0.6rem;
}

// 合作客户
// 关于
.customer {
  padding-top: 0.89rem;
  padding-bottom: 1.02rem;
  background-size: 7.5rem 3.78rem;
  background-position: bottom;
}
.customer-title {
  text-align: center;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282b45;
  line-height: 0.39rem;
}

.customer-desc {
  margin-top: 0.2rem;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #777995;
  line-height: 0.24rem;
  text-align: center;
}
.customer-show {
  background-color: #fff;
  margin: 0 auto;
  width: 7.03rem;
  display: flex;
  flex-flow: wrap;
  padding: 0.2rem;
  margin-top: 0.43rem;
  .customer-item {
    width: 2.1rem;
    height: 1.03rem;
    margin: 0.05rem;
    border: 1px solid #E2E2E9;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.op-0 {
  opacity: 0;
}
.linear {
  transition: transform 2s linear;
}
.popular-linear {
  transition: left 1s ease-in-out;
}
</style>
